import React, { useEffect } from 'react';
import './footer.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/store';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const isActive = (path: string): boolean => {
    if (path !== "/") {
      return window.location.pathname.startsWith(path)
    }else{
      return path === window.location.pathname
    }
    
  }
  const cart = useSelector((state: RootState) => state.cart)
  const dispatch = useDispatch<AppDispatch>()
  let HomeIcon = '/assets/icons/HomeIcon.svg';
  let HomeIconActive = '/assets/icons/HomeIconActive.svg';
  let CartIcon = '/assets/icons/CartIcon.svg';
  let CartIconActive = '/assets/icons/CartIconActive.svg';
  let OrderIcon = '/assets/icons/OrderIcon.svg';
  let OrderIconActive = '/assets/icons/OrderIconActive.svg';
  let ProfileIcon = '/assets/icons/ProfileIcon.svg';
  let ProfileIconActive = '/assets/icons/ProfileIconActive.svg';

  useEffect(() => {
    console.log('cart', cart);
  }, [cart])

  return (
    <footer className="footer-mobile">
      <button className={`footer-button ${isActive('/') ? 'active' : ''}`} onClick={() => navigate('/')}>
        <img src={isActive('/') ? HomeIconActive : HomeIcon} alt="Home" className="icon" />
        หน้าหลัก
      </button>
      <button className={`footer-button ${isActive('/cart') ? 'active' : ''}`} onClick={() => navigate('/cart')}>
        <div className="relative">
          <img src={isActive('/cart') ? CartIconActive : CartIcon} alt="Cart" className="icon" />
          {cart.totalItem > 0 && (
            <span className="absolute -top-1 -right-2 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
              {cart.totalItem}
            </span>
          )}
        </div>
        รถเข็น
      </button>
      <button className={`footer-button ${isActive('/order') ? 'active' : ''}`} onClick={() => navigate('/order')}>
        <img src={isActive('/order') ? OrderIconActive : OrderIcon} alt="Order" className="icon" />
        ออเดอร์
      </button>
      <button className={`footer-button ${isActive('/profile') ? 'active' : ''}`} onClick={() => navigate('/profile')}>
        <img src={isActive('/profile') ? ProfileIconActive : ProfileIcon} alt="Profile" className="icon" />
        โปร์ไฟล์
      </button>
    </footer>
  );
}

export default Footer;
